// ============================= INTERVIEW =============================

export const GET_INTERVIEW_TOKEN = 'GET_INTERVIEW_TOKEN';
export const GET_INTERVIEW_TOKEN_SUCCESS = 'GET_INTERVIEW_TOKEN_SUCCESS';
export const GET_INTERVIEW_TOKEN_FAILURE = 'GET_INTERVIEW_TOKEN_FAILURE';

export const GET_INTERVIEW = 'GET_INTERVIEW';
export const GET_INTERVIEW_SUCCESS = 'GET_INTERVIEW_SUCCESS';
export const GET_INTERVIEW_FAILURE = 'GET_INTERVIEW_FAILURE';

export const GET_QUESTION_NUMBER = 'GET_QUESTION_NUMBER';
export const GET_QUESTION_NUMBER_SUCCESS = 'GET_QUESTION_NUMBER_SUCCESS';
export const GET_QUESTION_NUMBER_FAILURE = 'GET_QUESTION_NUMBER_FAILURE';

export const GET_QUESTION = 'GET_QUESTION';
export const GET_QUESTION_SUCCESS = 'GET_QUESTION_SUCCESS';
export const GET_QUESTION_FAILURE = 'GET_QUESTION_FAILURE';

export const POST_INTERVIEW_STATUS = 'POST_INTERVIEW_STATUS';
export const POST_INTERVIEW_STATUS_SUCCESS = 'POST_INTERVIEW_STATUS_SUCCESS';
export const POST_INTERVIEW_STATUS_FAILURE = 'POST_INTERVIEW_STATUS_FAILURE';

export const POST_INTERVIEW_FEEDBACK = 'POST_INTERVIEW_FEEDBACK';
export const POST_INTERVIEW_FEEDBACK_SUCCESS = 'POST_INTERVIEW_FEEDBACK_SUCCESS';
export const POST_INTERVIEW_FEEDBACK_FAILURE = 'POST_INTERVIEW_FEEDBACK_FAILURE';

export const UPDATE_CANDIDATE = 'UPDATE_CANDIDATE';
export const UPDATE_CANDIDATE_SUCCESS = 'UPDATE_CANDIDATE_SUCCESS';
export const UPDATE_CANDIDATE_FAILURE = 'UPDATE_CANDIDATE_FAILURE';

export const RESEND_OTP_REQUEST = 'RESEND_OTP_REQUEST';
export const RESEND_OTP_REQUEST_SUCCESS = 'RESEND_OTP_REQUEST_SUCCESS';
export const RESEND_OTP_REQUEST_FAILURE = 'RESEND_OTP_REQUEST_FAILURE';

export const MOVEMENT = 'MOVEMENT';
export const MOVEMENT_SUCCESS = 'MOVEMENT_SUCCESS';
export const MOVEMENT_FAILURE = 'MOVEMENT_FAILURE';

export const CONTACT_ADMIN = 'CONTACT_ADMIN';
export const CONTACT_ADMIN_SUCCESS = 'CONTACT_ADMIN_SUCCESS';
export const CONTACT_ADMIN_FAILURE = 'CONTACT_ADMIN_FAILURE';

export const CANDIDATE_CALL_START = 'CANDIDATE_CALL_START';
export const CANDIDATE_CALL_START_SUCCESS = 'CANDIDATE_CALL_START_SUCCESS';
export const CANDIDATE_CALL_START_FAILURE = 'CANDIDATE_CALL_START_FAILURE';

export const CANDIDATE_CALL_END = 'CANDIDATE_CALL_END';
export const CANDIDATE_CALL_END_SUCCESS = 'CANDIDATE_CALL_END_SUCCESS';
export const CANDIDATE_CALL_END_FAILURE = 'CANDIDATE_CALL_END_FAILURE';

export const INTERVIEW_FEEDBACK_STATUS = 'INTERVIEW_FEEDBACK_STATUS';
export const INTERVIEW_FEEDBACK_STATUS_SUCCESS = 'INTERVIEW_FEEDBACK_STATUS_SUCCESS';
export const INTERVIEW_FEEDBACK_STATUS_FAILURE = 'INTERVIEW_FEEDBACK_STATUS_FAILURE';

export const VERIFY_CANDIDATE_KEY = 'VERIFY_CANDIDATE_KEY';
export const VERIFY_CANDIDATE_KEY_SUCCESS = 'VERIFY_CANDIDATE_KEY_SUCCESS';
export const VERIFY_CANDIDATE_KEY_FAILURE = 'VERIFY_CANDIDATE_KEY_FAILURE';

export const VERIFY_ROOM = 'VERIFY_ROOM';
export const VERIFY_ROOM_SUCCESS = 'VERIFY_ROOM_SUCCESS';
export const VERIFY_ROOM_FAILURE = 'VERIFY_ROOM_FAILURE';

export const CREATE_AND_UPDATE_SCREENSHOT = 'CREATE_AND_UPDATE_SCREENSHOT';
export const CREATE_AND_UPDATE_SCREENSHOT_SUCCESS = 'CREATE_AND_UPDATE_SCREENSHOT_SUCCESS';
export const CREATE_AND_UPDATE_SCREENSHOT_FAILURE = 'CREATE_AND_UPDATE_SCREENSHOT_FAILURE';

export const REMOVE_SCREENSHOT_IMAGE = 'REMOVE_SCREENSHOT_IMAGE';
export const FETCH_SCREENSHOT_IMAGE = 'FETCH_SCREENSHOT_IMAGE';
export const FETCH_SCREENSHOT_IMAGE_SUCCESS = 'FETCH_SCREENSHOT_IMAGE_SUCCESS';
export const FETCH_SCREENSHOT_IMAGE_FAILURE = 'FETCH_SCREENSHOT_IMAGE_FAILURE';

export const SWITCH_TAB = 'SWITCH_TAB';
export const SWITCH_TAB_SUCCESS = 'SWITCH_TAB_SUCCESS';
export const SWITCH_TAB_FAILURE = 'SWITCH_TAB_FAILURE';

export const SUBMIT_TRANSCRIBE = 'SUBMIT_TRANSCRIBE';
export const SUBMIT_TRANSCRIBE_SUCCESS = 'SUBMIT_TRANSCRIBE_SUCCESS';
export const SUBMIT_TRANSCRIBE_FAILURE = 'SUBMIT_TRANSCRIBE_FAILURE';

export const NOTIFICATION_ERROR = 'NOTIFICATION_ERROR';
export const NOTIFICATION_ERROR_SUCCESS = 'NOTIFICATION_ERROR_SUCCESS';
export const NOTIFICATION_ERROR_FAILURE = 'NOTIFICATION_ERROR_FAILURE';

export const FULL_FACE_DETECTION = 'FULL_FACE_DETECTION';
export const FULL_FACE_DETECTION_SUCCESS = 'FULL_FACE_DETECTION_SUCCESS';
export const FULL_FACE_DETECTION_FAILURE = 'FULL_FACE_DETECTION_FAILURE';

export const FULL_FACE_DETECTION_NEW = 'FULL_FACE_DETECTION_NEW';
export const FULL_FACE_DETECTION_NEW_SUCCESS = 'FULL_FACE_DETECTION_NEW_SUCCESS';
export const FULL_FACE_DETECTION_NEW_FAILURE = 'FULL_FACE_DETECTION_NEW_FAILURE';

export const CREATE_CODE_SUBMISSION = 'CREATE_CODE_SUBMISSION';
export const CREATE_CODE_SUBMISSION_SUCCESS = 'CREATE_CODE_SUBMISSION_SUCCESS';
export const CREATE_CODE_SUBMISSION_FAILURE = 'CREATE_CODE_SUBMISSION_FAILURE';
export const RESET_CODE_SUBMISSION_OUTPUT = 'RESET_CODE_SUBMISSION_OUTPUT';

export const SUBMIT_CODING_QUESTION = 'SUBMIT_CODING_QUESTION';
export const SUBMIT_CODING_QUESTION_SUCCESS = 'SUBMIT_CODING_QUESTION_SUCCESS';
export const SUBMIT_CODING_QUESTION_FAILURE = 'SUBMIT_CODING_QUESTION_FAILURE';

export const LOOKING_FORWARD = 'LOOKING_FORWARD';
export const LOOKING_FORWARD_SUCCESS = 'LOOKING_FORWARD_SUCCESS';
export const LOOKING_FORWARD_FAILURE = 'LOOKING_FORWARD_FAILURE';

export const UPLOAD_VIDEO = 'UPLOAD_VIDEO';
export const UPLOAD_VIDEO_SUCCESS = 'UPLOAD_VIDEO_SUCCESS';
export const UPLOAD_VIDEO_FAILURE = 'UPLOAD_VIDEO_FAILURE';

export const PRACTICE_QUESTION = 'PRACTICE_QUESTION';
export const PRACTICE_QUESTION_SUCCESS = 'PRACTICE_QUESTION_SUCCESS';
export const PRACTICE_QUESTION_FAILURE = 'PRACTICE_QUESTION_FAILURE';

export const PRACTICE_QUESTION_UPDATE = 'PRACTICE_QUESTION_UPDATE';
export const PRACTICE_QUESTION_UPDATE_SUCCESS = 'PRACTICE_QUESTION_UPDATE_SUCCESS';
export const PRACTICE_QUESTION_UPDATE_FAILURE = 'PRACTICE_QUESTION_UPDATE_FAILURE';

export const SUBMIT_MCQ = 'SUBMIT_MCQ';
export const SUBMIT_MCQ_SUCCESS = 'SUBMIT_MCQ_SUCCESS';
export const SUBMIT_MCQ_FAILURE = 'SUBMIT_MCQ_FAILURE';

export const SCREEN_SHARE_VID = 'SCREEN_SHARE_VID';

export const GET_DASHBOARD_DETAILS = 'GET_DASHBOARD_DETAILS';
export const GET_DASHBOARD_DETAILS_SUCCESS = 'GET_DASHBOARD_DETAILS_SUCCESS';
export const GET_DASHBOARD_DETAILS_FAILURE = 'GET_DASHBOARD_DETAILS_FAILURE';

export const GET_NOTIFICATION_LIST = 'GET_NOTIFICATION_LIST';
export const GET_NOTIFICATION_LIST_SUCCESS = 'GET_NOTIFICATION_LIST_SUCCESS';
export const GET_NOTIFICATION_LIST_FAILURE = 'GET_NOTIFICATION_LIST_FAILURE';

export const READ_NOTIFICATION_LIST = 'READ_NOTIFICATION_LIST';
export const READ_NOTIFICATION_LIST_FAILURE = 'READ_NOTIFICATION_LIST_FAILURE';
export const READ_NOTIFICATION_LIST_SUCCESS = 'READ_NOTIFICATION_LIST_SUCCESS';

export const CLEAR_NOTIFICATION_LIST = 'CLEAR_NOTIFICATION_LIST';
export const CLEAR_NOTIFICATION_LIST_SUCCESS = 'CLEAR_NOTIFICATION_LIST_SUCCESS';
export const CLEAR_NOTIFICATION_LIST_FAILURE = 'CLEAR_NOTIFICATION_LIST_FAILURE';

export const GET_INTERVIEW_DETAILS = 'GET_INTERVIEW_DETAILS';
export const GET_INTERVIEW_DETAILS_SUCCESS = 'GET_INTERVIEW_DETAILS_SUCCESS';
export const GET_INTERVIEW_DETAILS_FAILURE = 'GET_INTERVIEW_DETAILS_FAILURE';

export const RESEND_EMAIL = 'RESEND_EMAIL';
export const RESEND_EMAIL_SUCCESS = 'RESEND_EMAIL_SUCCESS';
export const RESEND_EMAIL_FAILURE = 'RESEND_EMAIL_FAILURE';

export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_PASSWORD_FAILURE = 'CHANGE_PASSWORD_FAILURE';

export const LOGOUT_USER = 'LOGOUT_USER';
export const LOGOUT_USER_SUCCESS = 'LOGOUT_USER_SUCCESS';
export const LOGOUT_USER_FAILURE = 'LOGOUT_USER_FAILURE';

export const GET_PLANS_AND_PRICING = 'GET_PLANS_AND_PRICING';
export const GET_PLANS_AND_PRICING_SUCCESS = 'GET_PLANS_AND_PRICING_SUCCESS';
export const GET_PLANS_AND_PRICING_FAILURE = 'GET_PLANS_AND_PRICING_FAILURE';

export const GET_BILLING_INFORMATION = 'GET_BILLING_INFORMATION';
export const GET_BILLING_INFORMATION_SUCCESS = 'GET_BILLING_INFORMATION_SUCCESS';
export const GET_BILLING_INFORMATION_FAILURE = 'GET_BILLING_INFORMATION_FAILURE';

export const GET_POSITION_LIST = 'GET_POSITION_LIST';
export const GET_POSITION_LIST_SUCCESS = 'GET_POSITION_LIST_SUCCESS';
export const GET_POSITION_LIST_FAILURE = 'GET_POSITION_LIST_FAILURE';

export const GET_MANDATORY_SKILL = 'GET_MANDATORY_SKILL';
export const GET_MANDATORY_SKILL_SUCCESS = 'GET_MANDATORY_SKILL_SUCCESS';
export const GET_MANDATORY_SKILL_FAILURE = 'GET_MANDATORY_SKILL_FAILURE';

export const FETCH_SKILLS_POSITION = 'FETCH_SKILLS_POSITION';
export const FETCH_SKILLS_POSITION_SUCCESS = 'FETCH_SKILLS_POSITION_SUCCESS';
export const FETCH_SKILLS_POSITION_FAILURE = 'FETCH_SKILLS_POSITION_FAILURE';

export const FETCH_SKILLS_JD = 'FETCH_SKILLS_JD';
export const FETCH_SKILLS_JD_SUCCESS = 'FETCH_SKILLS_JD_SUCCESS';
export const FETCH_SKILLS_JD_FAILURE = 'FETCH_SKILLS_JD_FAILURE';

export const POST_CHECKOUT = 'POST_CHECKOUT';
export const POST_CHECKOUT_SUCCESS = 'POST_CHECKOUT_SUCCESS';
export const POST_CHECKOUT_FAILURE = 'POST_CHECKOUT_FAILURE';

export const FETCH_RESUME_SCORE = 'FETCH_RESUME_SCORE';
export const FETCH_RESUME_SCORE_SUCCESS = 'FETCH_RESUME_SCORE_SUCCESS';
export const FETCH_RESUME_SCORE_FAILURE = 'FETCH_RESUME_SCORE_FAILURE';

export const GET_USER_INFORMATION = 'GET_USER_INFORMATION';
export const GET_USER_INFORMATION_SUCCESS = 'GET_USER_INFORMATION_SUCCESS';
export const GET_USER_INFORMATION_FAILURE = 'GET_USER_INFORMATION_FAILURE';

export const UPDATE_USER_INFORMATION = 'UPDATE_USER_INFORMATION';
export const UPDATE_USER_INFORMATION_SUCCESS = 'UPDATE_USER_INFORMATION_SUCCESS';
export const UPDATE_USER_INFORMATION_FAILURE = 'UPDATE_USER_INFORMATION_FAILURE';

export const SUPPORT_REQUEST = 'SUPPORT_REQUEST';
export const SUPPORT_REQUEST_SUCCESS = 'SUPPORT_REQUEST_SUCCESS';
export const SUPPORT_REQUEST_FAILURE = 'SUPPORT_REQUEST_FAILURE';

export const GET_SUPPORT_TICKET = 'GET_SUPPORT_TICKET';
export const GET_SUPPORT_TICKET_SUCCESS = 'GET_SUPPORT_TICKET_SUCCESS';
export const GET_SUPPORT_TICKET_FAILURE = 'GET_SUPPORT_TICKET_FAILURE';

export const CLOSE_SUPPORT_TICKET = 'CLOSE_SUPPORT_TICKET';
export const CLOSE_SUPPORT_TICKET_SUCCESS = 'CLOSE_SUPPORT_TICKET_SUCCESS';
export const CLOSE_SUPPORT_TICKET_FAILURE = 'CLOSE_SUPPORT_TICKET_FAILURE';

export const ORDER_UPDATE = 'ORDER_UPDATE';
export const ORDER_UPDATE_SUCCESS = 'ORDER_UPDATE_SUCCESS';
export const ORDER_UPDATE_FAILURE = 'ORDER_UPDATE_FAILURE';

export const CREATE_INTERVIEW = 'CREATE_INTERVIEW';
export const CREATE_INTERVIEW_SUCCESS = 'CREATE_INTERVIEW_SUCCESS';
export const CREATE_INTERVIEW_FAILURE = 'CREATE_INTERVIEW_FAILURE';

export const REPLICATE_INTERVIEW = 'REPLICATE_INTERVIEW';
export const REPLICATE_INTERVIEW_SUCCESS = 'REPLICATE_INTERVIEW_SUCCESS';
export const REPLICATE_INTERVIEW_FAILURE = 'REPLICATE_INTERVIEW_FAILURE';

export const VERIFY_PAYMENT = 'VERIFY_PAYMENT';
export const VERIFY_PAYMENT_SUCCESS = 'VERIFY_PAYMENT_SUCCESS';
export const VERIFY_PAYMENT_FAILURE = 'VERIFY_PAYMENT_FAILURE';

export const APPLY_COUPON = 'APPLY_COUPON';
export const APPLY_COUPON_SUCCESS = 'APPLY_COUPON_SUCCESS';
export const APPLY_COUPON_FAILURE = 'APPLY_COUPON_FAILURE';

export const POST_CONSENT = 'POST_CONSENT';
export const POST_CONSENT_SUCCESS = 'POST_CONSENT_SUCCESS';
export const POST_CONSENT_FAILURE = 'POST_CONSENT_FAILURE';

export const LIVE_KIT_TOKEN = 'LIVE_KIT_TOKEN';
export const LIVE_KIT_TOKEN_SUCCESS = 'LIVE_KIT_TOKEN_SUCCESS';
export const LIVE_KIT_TOKEN_FAILURE = 'LIVE_KIT_TOKEN_FAILURE';

export const GET_BANNERS = 'GET_BANNERS';
export const GET_BANNERS_SUCCESS = 'GET_BANNERS_SUCCESS';
export const GET_BANNERS_FAILURE = 'GET_BANNERS_FAILURE';

export const GET_SESSION_TOKEN = 'GET_SESSION_TOKEN';
export const GET_SESSION_TOKEN_SUCCESS = 'GET_SESSION_TOKEN_SUCCESS';
export const GET_SESSION_TOKEN_FAILURE = 'GET_SESSION_TOKEN_FAILURE';
